import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dashboard-view" }
const _hoisted_2 = {
  key: 0,
  class: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "text-red-700 dark:text-red-300" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" }
const _hoisted_7 = { class: "card p-6 relative flex flex-col min-h-[140px]" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "flex-shrink-0" }
const _hoisted_10 = { class: "ml-5 w-0 flex-1" }
const _hoisted_11 = { class: "text-lg font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_12 = { class: "pt-4" }
const _hoisted_13 = { class: "flex flex-wrap gap-2" }
const _hoisted_14 = { class: "flex items-center rounded-md bg-green-50 dark:bg-green-900/20 px-3 py-1.5 border border-green-200 dark:border-green-800" }
const _hoisted_15 = { class: "text-xs text-primary-text dark:text-primary-dark-text font-semibold" }
const _hoisted_16 = { class: "flex items-center rounded-md bg-red-50 dark:bg-red-900/20 px-3 py-1.5 border border-red-200 dark:border-red-800" }
const _hoisted_17 = { class: "text-xs text-primary-text dark:text-primary-dark-text font-semibold" }
const _hoisted_18 = { class: "flex items-center rounded-md bg-yellow-50 dark:bg-yellow-900/20 px-3 py-1.5 border border-yellow-200 dark:border-yellow-800" }
const _hoisted_19 = { class: "text-xs text-primary-text dark:text-primary-dark-text font-semibold" }
const _hoisted_20 = { class: "card p-6 relative flex flex-col min-h-[140px]" }
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = { class: "flex-shrink-0" }
const _hoisted_23 = { class: "ml-5 w-0 flex-1" }
const _hoisted_24 = { class: "text-sm font-medium text-secondary-text dark:text-secondary-dark-text truncate" }
const _hoisted_25 = { class: "text-lg font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_26 = { class: "pt-4" }
const _hoisted_27 = { class: "flex flex-wrap gap-2" }
const _hoisted_28 = {
  key: 0,
  class: "flex items-center rounded-md bg-green-50 dark:bg-green-900/20 px-3 py-1.5 border border-green-200 dark:border-green-800"
}
const _hoisted_29 = { class: "text-xs text-green-700 dark:text-green-300 font-medium" }
const _hoisted_30 = {
  key: 0,
  class: "ml-2 text-[10px] text-gray-600 dark:text-gray-300"
}
const _hoisted_31 = ["title"]
const _hoisted_32 = {
  key: 1,
  class: "flex items-center rounded-md bg-gray-50 dark:bg-gray-900/20 px-3 py-1.5 border border-gray-200 dark:border-gray-800"
}
const _hoisted_33 = { class: "card p-6 relative flex flex-col min-h-[140px]" }
const _hoisted_34 = { class: "flex items-center" }
const _hoisted_35 = { class: "flex-shrink-0" }
const _hoisted_36 = { class: "ml-5 w-0 flex-1" }
const _hoisted_37 = { class: "text-lg font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_38 = { class: "mt-auto pt-4" }
const _hoisted_39 = { class: "flex flex-wrap gap-2" }
const _hoisted_40 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_41 = ["title"]
const _hoisted_42 = { class: "card p-6 mb-8" }
const _hoisted_43 = { class: "flex items-center justify-between mb-6" }
const _hoisted_44 = { class: "text-xl font-semibold text-primary-text dark:text-primary-dark-text mb-2" }
const _hoisted_45 = { class: "text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_46 = { class: "hidden md:block" }
const _hoisted_47 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6" }
const _hoisted_48 = { class: "flex items-center p-4 bg-primary-bg/10 dark:bg-primary-dark-bg/10 rounded-lg" }
const _hoisted_49 = { class: "font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_50 = { class: "flex items-center p-4 bg-primary-bg/10 dark:bg-primary-dark-bg/10 rounded-lg" }
const _hoisted_51 = { class: "font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_52 = { class: "flex items-center p-4 bg-primary-bg/10 dark:bg-primary-dark-bg/10 rounded-lg" }
const _hoisted_53 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-h-64 overflow-y-auto training-modules-container" }
const _hoisted_56 = { class: "flex items-start justify-between mb-2" }
const _hoisted_57 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text line-clamp-1" }
const _hoisted_58 = { class: "text-xs text-secondary-text dark:text-secondary-dark-text mb-3 line-clamp-2" }
const _hoisted_59 = { class: "flex items-center justify-between" }
const _hoisted_60 = { class: "flex items-center space-x-2" }
const _hoisted_61 = {
  key: 0,
  class: "text-xs text-blue-600 dark:text-blue-400"
}
const _hoisted_62 = {
  key: 1,
  class: "text-xs text-gray-500 dark:text-gray-400"
}
const _hoisted_63 = { class: "flex items-start justify-between mb-2" }
const _hoisted_64 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text line-clamp-1" }
const _hoisted_65 = { class: "text-xs text-secondary-text dark:text-secondary-dark-text mb-3 line-clamp-2" }
const _hoisted_66 = { class: "flex items-center justify-between" }
const _hoisted_67 = { class: "flex items-center space-x-2" }
const _hoisted_68 = {
  key: 0,
  class: "text-xs text-blue-600 dark:text-blue-400"
}
const _hoisted_69 = {
  key: 1,
  class: "text-xs text-gray-500 dark:text-gray-400"
}
const _hoisted_70 = {
  key: 0,
  class: "mt-4 text-center"
}
const _hoisted_71 = {
  key: 1,
  class: "text-center py-8"
}
const _hoisted_72 = { class: "text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_73 = { class: "flex flex-col lg:flex-row gap-6" }
const _hoisted_74 = { class: "card p-6 flex flex-col flex-1 h-[463px]" }
const _hoisted_75 = { class: "flex items-center justify-between mb-4" }
const _hoisted_76 = { class: "text-xl font-semibold text-primary-text dark:text-primary-dark-text flex items-center gap-2" }
const _hoisted_77 = ["title"]
const _hoisted_78 = { class: "flex items-center gap-2" }
const _hoisted_79 = {
  key: 0,
  class: "flex-1 flex items-center justify-center"
}
const _hoisted_80 = { class: "text-center" }
const _hoisted_81 = {
  key: 1,
  class: "flex-1 max-h-[48rem] overflow-y-auto space-y-4 pr-2 notifications-container pt-3"
}
const _hoisted_82 = ["onClick"]
const _hoisted_83 = {
  key: 0,
  class: "absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse",
  title: "New"
}
const _hoisted_84 = { class: "flex-shrink-0" }
const _hoisted_85 = { class: "ml-3 flex-1 min-w-0" }
const _hoisted_86 = { class: "flex items-center flex-wrap gap-2" }
const _hoisted_87 = { class: "text-xs text-secondary-text dark:text-secondary-dark-text flex items-center" }
const _hoisted_88 = { class: "card p-6 flex-1 flex flex-col h-full" }
const _hoisted_89 = { class: "flex items-center justify-between mb-4" }
const _hoisted_90 = { class: "text-lg font-medium text-primary-text dark:text-primary-dark-text flex items-center" }
const _hoisted_91 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = { class: "flex items-center space-x-2" }
const _hoisted_95 = {
  key: 0,
  class: "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300 no-wrap-badge"
}
const _hoisted_96 = {
  key: 1,
  class: "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-900/20 dark:text-gray-300 no-wrap-badge"
}
const _hoisted_97 = {
  key: 0,
  class: "flex flex-col items-center justify-center flex-1 min-h-[200px] text-center p-8"
}
const _hoisted_98 = { class: "w-16 h-16 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center mb-4" }
const _hoisted_99 = { class: "text-sm text-gray-500 dark:text-gray-500 mb-4 max-w-sm" }
const _hoisted_100 = { class: "flex items-center text-xs text-blue-600 dark:text-blue-400" }
const _hoisted_101 = {
  key: 1,
  class: "flex flex-col items-center justify-center flex-1 min-h-[200px] text-center p-8"
}
const _hoisted_102 = { class: "w-16 h-16 bg-blue-100 dark:bg-blue-900/20 rounded-full flex items-center justify-center mb-4" }
const _hoisted_103 = { class: "inline-flex items-center px-4 py-2 rounded-lg bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300" }
const _hoisted_104 = {
  key: 2,
  class: "flex-1"
}
const _hoisted_105 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_106 = { class: "flex items-start justify-between mb-4" }
const _hoisted_107 = { class: "flex-1" }
const _hoisted_108 = { class: "flex items-center mb-3" }
const _hoisted_109 = { class: "text-xl font-semibold text-primary-text dark:text-primary-dark-text mb-2" }
const _hoisted_110 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text leading-relaxed" }
const _hoisted_111 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-5" }
const _hoisted_112 = { class: "bg-white dark:bg-gray-800/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700 border-l-4 border-l-primary shadow-sm transition-all duration-200 hover:shadow-md flex flex-col" }
const _hoisted_113 = { class: "flex items-center mb-3" }
const _hoisted_114 = { class: "flex-1 flex items-center justify-center" }
const _hoisted_115 = {
  key: 0,
  class: "text-2xl text-primary-text dark:text-primary-dark-text font-semibold text-center"
}
const _hoisted_116 = {
  key: 1,
  class: "text-lg text-gray-500 text-center"
}
const _hoisted_117 = { class: "bg-white dark:bg-gray-800/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700 border-l-4 border-l-primary shadow-sm transition-all duration-200 hover:shadow-md" }
const _hoisted_118 = { class: "flex items-center mb-2" }
const _hoisted_119 = {
  key: 0,
  class: "space-y-1"
}
const _hoisted_120 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_121 = { class: "flex items-center text-xs text-gray-600 dark:text-gray-400" }
const _hoisted_122 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_123 = { class: "flex items-center justify-between pt-2 border-t border-gray-100 dark:border-gray-700" }
const _hoisted_124 = { class: "flex items-center space-x-2" }
const _hoisted_125 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_126 = {
  key: 1,
  class: "space-y-3 max-h-[24rem] overflow-y-auto hide-scrollbar"
}
const _hoisted_127 = { class: "flex-1 min-w-0" }
const _hoisted_128 = { class: "flex items-center mb-1" }
const _hoisted_129 = { class: "font-medium text-primary-text dark:text-primary-dark-text truncate" }
const _hoisted_130 = { class: "text-xs text-secondary-text dark:text-secondary-dark-text truncate mb-2" }
const _hoisted_131 = { class: "flex items-center space-x-4 text-xs" }
const _hoisted_132 = {
  key: 0,
  class: "flex items-center text-blue-600 dark:text-blue-400"
}
const _hoisted_133 = {
  key: 1,
  class: "flex items-center text-purple-600 dark:text-purple-400"
}
const _hoisted_134 = { class: "ml-4 flex flex-col items-end space-y-2" }
const _hoisted_135 = { class: "flex items-center space-x-1" }

import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useTitle } from '@/composables/ui/useTitle'
import { useUser } from '@/composables/auth/useUser'
import { useToastService } from '@/services/toast'
import { dashboardApi, type DashboardStats, type Activity } from '@/services/dashboard'
import { employeeAssignmentApi, type AccessibleModules } from '@/services/employeeAssignment'
import moduleAccessService, { type ModuleAccessRecord } from '@/services/moduleAccess'
import { useActivityPolling, type ActivityWithReadStatus } from '@/composables/notifications/useActivityPolling'

import {
  XCircle,
  Archive,
  CheckCircle,
  Clock,
  LayoutDashboard,
  FileText,
  ClipboardList,
  Calendar,
  BookOpen,
  Users,
  Award,
  AlertCircle,
  PlayCircle,
  UserPlus
} from 'lucide-vue-next'
import BaseButton from '@/components/common/BaseButton.vue'
import { LoadingState } from '@/components/common'


export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeDashboardView',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Empathy Health Services, Inc.')
useTitle(`Dashboard - ${appTitle.value}`)

// Composables
const router = useRouter()
const toast = useToastService()
const { userName } = useUser()

// State
const loading = ref(true)
const error = ref<string | null>(null)
const stats = ref<DashboardStats>({
  totalModules: 0,
  totalExams: 0,
  passedExams: 0,
  failedExams: 0,
  skippedExams: 0,
  currentExams: 0,
  upcomingExams: 0
})
const recentActivity = ref<Activity[]>([])
const accessibleModules = ref<AccessibleModules | null>(null)
const currentYear = new Date().getFullYear()
const moduleAccessMap = ref<Map<number, ModuleAccessRecord>>(new Map())

// Activity polling with notifications
const {
  activities: polledActivities,
  unreadActivitiesCount,
  clearNewActivitiesCount,
  markAsRead,
  markAllAsRead,
  refresh: refreshActivities
} = useActivityPolling({
  enableToasts: false,
  autoStart: true,
  isAdmin: false
})

// Use polled activities as the source of truth
const displayActivities = computed<ActivityWithReadStatus[]>(() => {
  if (polledActivities.value.length > 0) {
    return polledActivities.value
  }
  // Fallback to recentActivity with default read status
  return recentActivity.value.map(activity => ({
    ...activity,
    isRead: false,
    isNew: false
  }))
})
// loadingStates removed — dashboard no longer starts modules directly

// Computed properties
const currentMonthName = computed(() => {
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ]
  return monthNames[new Date().getMonth()]
})

const totalAvailableModules = computed(() => {
  return accessibleModules.value?.accessible_modules_count || 0
})

const modulesWithExams = computed(() => {
  const current = accessibleModules.value?.current_month_modules.filter(m => m.exam) || []
  const previous = accessibleModules.value?.previous_modules.filter(m => m.exam) || []
  return current.length + previous.length
})

// (Removed passed/failed/skipped counts — display only month access pills as requested)

const currentMonthModules = computed(() => {
  return accessibleModules.value?.current_month_modules || []
})

const hasCurrentMonthAccess = computed(() => {
  return accessibleModules.value?.has_current_month_access || false
})

// Primary module name for current month and overflow helpers
const primaryCurrentMonthModule = computed(() => {
  const mods = currentMonthModules.value || []
  if (mods.length === 0) return ''
  // AccessibleModule has `name` property
  return mods[0].name || ''
})

const currentMonthModuleOverflow = computed(() => {
  const len = currentMonthModules.value?.length || 0
  return len > 1 ? len - 1 : 0
})

const currentMonthOtherModulesTooltip = computed(() => {
  if ((currentMonthModules.value?.length || 0) <= 1) return ''
  return currentMonthModules.value.slice(1).map(m => m.name || '').join(', ')
})

// Training progress helpers: group modules by month and show up to 3 months
const modulesByMonth = computed(() => {
  // Build a map of month name -> module names
  const map = new Map<string, string[]>()

  const pushModule = (monthName: string | undefined, moduleName: string | undefined) => {
    if (!monthName || !moduleName) return
  if (!map.has(monthName)) map.set(monthName, [])
  const arr = map.get(monthName)
  if (arr) arr.push(moduleName)
  }

  // Previous modules may include available_in_months — use those if present, otherwise group under 'Previous'
  (accessibleModules.value?.previous_modules || []).forEach(m => {
    if (m.available_in_months && m.available_in_months.length) {
      m.available_in_months.forEach(am => pushModule(am.name, m.name))
    } else {
      pushModule('Previous', m.name)
    }
  })

  // Current month modules grouped under current month name
  const currentName = currentMonthName.value
  ;(accessibleModules.value?.current_month_modules || []).forEach(m => pushModule(currentName, m.name))

  // Convert map to an array of { month, modules }
  return Array.from(map.entries()).map(([month, modules]) => ({ month, modules }))
})

// (We render all month groups via `modulesByMonth` above)

// Methods
const fetchDashboardData = async () => {
  try {
    loading.value = true
    error.value = null

    // Fetch accessible modules and activity data
    const [accessibleData, dashboardStats, activity] = await Promise.all([
      employeeAssignmentApi.getMyAccessibleModules(currentYear),
      dashboardApi.getStats(),
      dashboardApi.getRecentActivity()
    ])

    accessibleModules.value = accessibleData
    
    // Calculate stats from accessible modules data
    const currentModules = accessibleData.current_month_modules
    const previousModules = accessibleData.previous_modules
    
    // Update stats with backend data (backend already calculates these correctly from exam_results table)
    stats.value = {
      ...dashboardStats,
      totalModules: accessibleData.accessible_modules_count,
      totalExams: [...currentModules, ...previousModules].filter(m => m.exam).length,
      // Use backend-provided exam counts (from exam_results table) instead of calculating from completion_status
      // passedExams, failedExams, and skippedExams are already in dashboardStats
      currentExams: currentModules.length,
      upcomingExams: Math.max(0, accessibleData.accessible_modules_count - currentModules.length - previousModules.length)
    }
    
    recentActivity.value = activity
    
    // Load module access data for current month modules
    await loadAllModuleAccess()

  } catch (err) {
    error.value = 'Failed to load dashboard data. Please try again.'
    console.error('Dashboard data fetch error:', err)
  } finally {
    loading.value = false
  }
}

const formatDate = (timestamp: string) => {
  const date = new Date(timestamp)
  const now = new Date()
  const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60))

  if (diffInHours < 1) {
    return 'Just now'
  } else if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`
  } else {
    const diffInDays = Math.floor(diffInHours / 24)
    return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`
  }
}

const formatDateRange = (startDate: string, endDate: string) => {
  const start = new Date(startDate)
  const end = new Date(endDate)
  
  const startMonth = start.toLocaleDateString('en-US', { month: 'long' })
  const endMonth = end.toLocaleDateString('en-US', { month: 'long' })
  const startDay = start.getDate()
  const endDay = end.getDate()
  const year = end.getFullYear()
  
  if (start.getMonth() === end.getMonth()) {
    return `${startMonth} ${startDay}-${endDay}, ${year}`
  } else {
    return `${startMonth} ${startDay} - ${endMonth} ${endDay}, ${year}`
  }
}



// Navigation functions
// Redirect to My Modules page
const viewModuleRedirect = () => {
  try {
    router.push('/my-modules')
  } catch (error) {
    console.error('Navigation error:', error)
    toast.error('Failed to navigate to My Modules')
  }
}

// Handle refresh activities and mark as viewed
const handleRefreshActivities = async () => {
  await refreshActivities()
  clearNewActivitiesCount()
}

// Handle activity click - mark as read
const handleActivityClick = (activity: any) => {
  if (!activity.isRead) {
    markAsRead(activity.id)
  }
}

// Handle mark all as read
const handleMarkAllAsRead = () => {
  markAllAsRead()
  clearNewActivitiesCount()
}

// Module navigation/start logic removed from dashboard. Use My Modules page for actions.

// Module Access Helper Methods
const loadModuleAccess = async (moduleId: number) => {
  try {
    const moduleAccess = await moduleAccessService.getModuleAccessStatus(moduleId)
    moduleAccessMap.value.set(moduleId, moduleAccess)
  } catch (error) {
    console.error('Error loading module access:', error)
  }
}

const loadAllModuleAccess = async () => {
  if (!currentMonthModules.value?.length) return
  
  try {
    const accessPromises = currentMonthModules.value.map(module => 
      loadModuleAccess(module.module_id)
    )
    await Promise.all(accessPromises)
  } catch (error) {
    console.error('Error loading module access data:', error)
  }
}

// Helper methods for module display
const getModuleStatusText = (completionStatus?: string) => {
  switch (completionStatus) {
    case 'completed_passed':
      return 'Passed'
    case 'completed_failed':
      return 'Failed'
    case 'not_attempted':
      return 'Skipped'
    case 'no_exam_required':
      return 'Complete'
    default:
      return 'Unknown'
  }
}

const getModuleActiveStatus = (module: any) => {
  if (module.completion_status === 'completed_passed' || module.completion_status === 'no_exam_required') {
    return 'active'
  } else if (module.completion_status === 'completed_failed' || module.completion_status === 'not_attempted') {
    return 'inactive'
  }
  // For current month modules, check if they have an active status
  return module.status === 1 ? 'active' : 'inactive'
}



const formatEndDate = (dateString?: string) => {
  if (!dateString) return 'N/A'
  try {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    })
  } catch {
    return 'Invalid date'
  }
}

// Note: Module start/exam actions removed from dashboard per requirement.

// Activity Icon Helper Methods
const getActivityIcon = (type: string, status?: string) => {
  switch (type) {
    case 'exam_result':
      return status === 'passed' ? Award : AlertCircle
    case 'module_completion':
      return CheckCircle
    case 'module_start':
      return PlayCircle
    case 'module_assignment':
      return UserPlus
    default:
      return Clock
  }
}

const getActivityIconClass = (type: string, status?: string) => {
  switch (type) {
    case 'exam_result':
      return status === 'passed' ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'
    case 'module_completion':
      return 'text-blue-600 dark:text-blue-400'
    case 'module_start':
      return 'text-purple-600 dark:text-purple-400'
    case 'module_assignment':
      return 'text-indigo-600 dark:text-indigo-400'
    default:
      return 'text-gray-600 dark:text-gray-400'
  }
}

const getActivityIconBgClass = (type: string, status?: string) => {
  switch (type) {
    case 'exam_result':
      return status === 'passed' 
        ? 'bg-green-100 dark:bg-green-900/20' 
        : 'bg-red-100 dark:bg-red-900/20'
    case 'module_completion':
      return 'bg-blue-100 dark:bg-blue-900/20'
    case 'module_start':
      return 'bg-purple-100 dark:bg-purple-900/20'
    case 'module_assignment':
      return 'bg-indigo-100 dark:bg-indigo-900/20'
    default:
      return 'bg-gray-100 dark:bg-gray-900/20'
  }
}

const getActivityBadgeClass = (status: string) => {
  switch (status) {
    case 'passed':
      return 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300'
    case 'failed':
      return 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300'
    case 'completed':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300'
    case 'in_progress':
      return 'bg-purple-100 text-purple-800 dark:bg-purple-900/20 dark:text-purple-300'
    case 'assigned':
      return 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/20 dark:text-indigo-300'
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-900/20 dark:text-gray-300'
  }
}

const getActivityStatusLabel = (status: string) => {
  switch (status) {
    case 'passed':
      return 'Passed'
    case 'failed':
      return 'Failed'
    case 'completed':
      return 'Completed'
    case 'in_progress':
      return 'In Progress'
    case 'assigned':
      return 'Assigned'
    default:
      return status
  }
}

// Lifecycle
onMounted(() => {
  fetchDashboardData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "mb-6" }, [
      _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-primary-text dark:text-primary-dark-text mb-2" }, " Dashboard "),
      _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text" }, " Welcome back! Here's an overview of your account and activities. ")
    ], -1)),
    _createVNode(_unref(LoadingState), {
      "is-loading": loading.value,
      type: "dashboard",
      text: "Loading dashboard..."
    }, null, 8, ["is-loading"]),
    (!loading.value && error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(XCircle), { class: "w-5 h-5 text-red-500 mr-2" }),
            _createElementVNode("span", _hoisted_4, _toDisplayString(error.value), 1)
          ]),
          _createElementVNode("button", {
            onClick: fetchDashboardData,
            class: "mt-2 text-sm text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-200 underline"
          }, " Try again ")
        ]))
      : _createCommentVNode("", true),
    (!loading.value && !error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(ClipboardList), { class: "w-8 h-8 text-blue-500" })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("dl", null, [
                    _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "text-sm font-medium text-secondary-text dark:text-secondary-dark-text truncate" }, " Available Exams ", -1)),
                    _createElementVNode("dd", _hoisted_11, _toDisplayString(stats.value.totalExams), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_unref(CheckCircle), { class: "w-4 h-4 text-green-600 dark:text-green-400 mr-1.5 flex-shrink-0" }),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-xs text-green-700 dark:text-green-300 font-medium mr-1" }, "Passed:", -1)),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(stats.value.passedExams), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_unref(XCircle), { class: "w-4 h-4 text-red-600 dark:text-red-400 mr-1.5 flex-shrink-0" }),
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-xs text-red-700 dark:text-red-300 font-medium mr-1" }, "Failed:", -1)),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(stats.value.failedExams), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_unref(Archive), { class: "w-4 h-4 text-yellow-600 dark:text-yellow-400 mr-1.5 flex-shrink-0" }),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-xs text-yellow-700 dark:text-yellow-300 font-medium mr-1" }, "Skipped:", -1)),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(stats.value.skippedExams), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_unref(Calendar), { class: "w-8 h-8 text-purple-500" })
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("dl", null, [
                    _createElementVNode("dt", _hoisted_24, _toDisplayString(currentMonthName.value) + " Access ", 1),
                    _createElementVNode("dd", _hoisted_25, _toDisplayString(hasCurrentMonthAccess.value ? 'Available' : 'No Access'), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  (hasCurrentMonthAccess.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createVNode(_unref(CheckCircle), { class: "w-4 h-4 text-green-600 dark:text-green-400 mr-1.5 flex-shrink-0" }),
                        _createElementVNode("span", _hoisted_29, [
                          _createTextVNode(_toDisplayString(primaryCurrentMonthModule.value || 'Monthly Module Access') + " ", 1),
                          (currentMonthModuleOverflow.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, "+" + _toDisplayString(currentMonthModuleOverflow.value), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (currentMonthModuleOverflow.value > 0)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              title: currentMonthOtherModulesTooltip.value,
                              class: "sr-only"
                            }, "Additional modules", 8, _hoisted_31))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createVNode(_unref(XCircle), { class: "w-4 h-4 text-gray-600 dark:text-gray-400 mr-1.5 flex-shrink-0" }),
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-xs text-gray-700 dark:text-gray-300 font-medium" }, "Not assigned this month", -1))
                      ]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_unref(Users), { class: "w-8 h-8 text-green-500" })
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("dl", null, [
                    _cache[5] || (_cache[5] = _createElementVNode("dt", { class: "text-sm font-medium text-secondary-text dark:text-secondary-dark-text truncate" }, " Training Progress ", -1)),
                    _createElementVNode("dd", _hoisted_37, _toDisplayString(totalAvailableModules.value) + " Total Modules ", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modulesByMonth.value, (group, idx) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: `month-${idx}`,
                        title: group.modules.join(', '),
                        class: "inline-flex items-center px-3 py-1 rounded-md text-xs bg-gray-50 dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700"
                      }, _toDisplayString(group.month), 9, _hoisted_41))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_44, " Welcome, " + _toDisplayString(_unref(userName)) + "! ", 1),
                _createElementVNode("p", _hoisted_45, " You're logged in as an Employee. Here's your training summary for " + _toDisplayString(_unref(currentYear)) + ": ", 1)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createVNode(_unref(LayoutDashboard), { class: "w-16 h-16 text-primary/20" })
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_unref(Archive), { class: "w-6 h-6 text-primary mr-3" }),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_49, _toDisplayString(totalAvailableModules.value) + " Modules ", 1),
                  _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, " Training materials assigned ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_unref(ClipboardList), { class: "w-6 h-6 text-primary mr-3" }),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_51, _toDisplayString(modulesWithExams.value) + " Exams ", 1),
                  _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, " Assessments available ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_unref(Calendar), { class: "w-6 h-6 text-primary mr-3" }),
                _createElementVNode("div", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "font-medium text-primary-text dark:text-primary-dark-text" }, " Current Month ", -1)),
                  _createElementVNode("p", _hoisted_53, " Module available in " + _toDisplayString(currentMonthName.value), 1)
                ])
              ])
            ]),
            (accessibleModules.value && (accessibleModules.value.current_month_modules.length > 0 || accessibleModules.value.previous_modules.length > 0))
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-md font-medium text-primary-text dark:text-primary-dark-text mb-4" }, " Your Training Modules ", -1)),
                  _createElementVNode("div", _hoisted_55, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accessibleModules.value.current_month_modules, (module) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `current-${module.module_id}`,
                        class: "border border-gray-200 dark:border-gray-700 rounded-lg p-4 bg-white dark:bg-gray-800"
                      }, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("h4", _hoisted_57, _toDisplayString(module.name), 1),
                          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300" }, " Current ", -1))
                        ]),
                        _createElementVNode("p", _hoisted_58, _toDisplayString(module.description || 'No description available'), 1),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            (module.exam)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Has Exam"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_62, "No Exam"))
                          ]),
                          _createElementVNode("button", {
                            onClick: viewModuleRedirect,
                            class: "text-xs text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-200"
                          }, " View → ")
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accessibleModules.value.previous_modules.slice(0, 6), (module) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `previous-${module.module_id}`,
                        class: "border border-gray-200 dark:border-gray-700 rounded-lg p-4 bg-white dark:bg-gray-800"
                      }, [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("h4", _hoisted_64, _toDisplayString(module.name), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium", {
                  'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300': module.completion_status === 'completed_passed',
                  'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300': module.completion_status === 'completed_failed',
                  'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-300': module.completion_status === 'not_attempted',
                  'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300': module.completion_status === 'no_exam_required'
                }])
                          }, _toDisplayString(getModuleStatusText(module.completion_status)), 3)
                        ]),
                        _createElementVNode("p", _hoisted_65, _toDisplayString(module.description || 'No description available'), 1),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            (module.exam)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_68, "Has Exam"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_69, "No Exam"))
                          ]),
                          _createElementVNode("button", {
                            onClick: viewModuleRedirect,
                            class: "text-xs text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-200"
                          }, " View → ")
                        ])
                      ]))
                    }), 128))
                  ]),
                  (accessibleModules.value.previous_modules.length > 6)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                        _createElementVNode("button", {
                          onClick: viewModuleRedirect,
                          class: "text-sm text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-200"
                        }, " View all " + _toDisplayString(accessibleModules.value.previous_modules.length) + " previous modules → ", 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_71, [
                  _createVNode(_unref(Archive), { class: "w-16 h-16 text-gray-300 mx-auto mb-4" }),
                  _createElementVNode("p", _hoisted_72, " No modules assigned for " + _toDisplayString(_unref(currentYear)) + ". Contact your administrator for assignments. ", 1)
                ]))
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("h2", _hoisted_76, [
                  _cache[11] || (_cache[11] = _createTextVNode(" Notifications ", -1)),
                  (_unref(unreadActivitiesCount) > 0)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "inline-flex items-center justify-center px-2 py-0.5 rounded-full text-xs font-bold bg-blue-500 text-white",
                        title: `${_unref(unreadActivitiesCount)} unread notification${_unref(unreadActivitiesCount) > 1 ? 's' : ''}`
                      }, _toDisplayString(_unref(unreadActivitiesCount)), 9, _hoisted_77))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_78, [
                  (_unref(unreadActivitiesCount) > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: handleMarkAllAsRead,
                        class: "px-3 py-1.5 text-xs font-medium text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-colors",
                        title: "Mark all as read"
                      }, " Mark all read "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    onClick: handleRefreshActivities,
                    class: "p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors",
                    title: "Refresh notifications"
                  }, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-secondary-text dark:text-secondary-dark-text",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                      })
                    ], -1)
                  ]))])
                ])
              ]),
              (displayActivities.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _createVNode(_unref(FileText), { class: "w-12 h-12 text-gray-400 mx-auto mb-4" }),
                      _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text" }, " No recent activity to display ", -1))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayActivities.value, (activity) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: activity.id,
                        onClick: ($event: any) => (handleActivityClick(activity)),
                        class: _normalizeClass([
                // add right padding so the absolutely-positioned status badge doesn't overlap text
                'relative flex items-start gap-3 p-3 pr-24 rounded-lg transition-all duration-200 cursor-pointer',
                activity.isRead 
                  ? 'bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700' 
                  : 'bg-blue-50 dark:bg-blue-900/20 hover:bg-blue-100 dark:hover:bg-blue-900/30 border-l-4 border-blue-500'
              ])
                      }, [
                        (activity.isNew && !activity.isRead)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_83))
                          : _createCommentVNode("", true),
                        (activity.status)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass([ 'activity-status-badge absolute top-3 right-3 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium', getActivityBadgeClass(activity.status) ])
                            }, _toDisplayString(getActivityStatusLabel(activity.status)), 3))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("div", {
                            class: _normalizeClass([getActivityIconBgClass(activity.type, activity.status), "w-10 h-10 rounded-full flex items-center justify-center"])
                          }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(getActivityIcon(activity.type, activity.status)), {
                              class: _normalizeClass([getActivityIconClass(activity.type, activity.status), "w-5 h-5"])
                            }, null, 8, ["class"]))
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("p", {
                            class: _normalizeClass([
                  'text-sm mb-1',
                  activity.isRead ? 'font-normal text-secondary-text dark:text-secondary-dark-text' : 'font-semibold text-primary-text dark:text-primary-dark-text'
                ])
                          }, _toDisplayString(activity.description), 3),
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("p", _hoisted_87, [
                              _createVNode(_unref(Clock), { class: "w-3 h-3 mr-1" }),
                              _createTextVNode(" " + _toDisplayString(formatDate(activity.timestamp)), 1)
                            ])
                          ])
                        ])
                      ], 10, _hoisted_82))
                    }), 128))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_90, [
                    _createVNode(_unref(Calendar), { class: "w-5 h-5 mr-2 text-blue-500" }),
                    _createTextVNode(" " + _toDisplayString(currentMonthName.value) + " Training ", 1)
                  ]),
                  _createElementVNode("p", _hoisted_91, [
                    (hasCurrentMonthAccess.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(currentMonthModules.value.length) + " module" + _toDisplayString(currentMonthModules.value.length !== 1 ? 's' : '') + " available this month", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_93, "No training scheduled this month"))
                  ])
                ]),
                _createElementVNode("div", _hoisted_94, [
                  (hasCurrentMonthAccess.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                        _createVNode(_unref(CheckCircle), { class: "w-3 h-3 mr-1 hide-on-480" }),
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "badge-text" }, "Active Access", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_96, [
                        _createVNode(_unref(XCircle), { class: "w-3 h-3 mr-1 hide-on-480" }),
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "badge-text" }, "No Access", -1))
                      ]))
                ])
              ]),
              (!hasCurrentMonthAccess.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                    _createElementVNode("div", _hoisted_98, [
                      _createVNode(_unref(Calendar), { class: "w-8 h-8 text-gray-400" })
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("h4", { class: "text-lg font-medium text-gray-600 dark:text-gray-400 mb-2" }, "No Training This Month", -1)),
                    _createElementVNode("p", _hoisted_99, " You don't have any modules assigned for " + _toDisplayString(currentMonthName.value) + ". Check your assignment calendar or contact your administrator. ", 1),
                    _createElementVNode("div", _hoisted_100, [
                      _createVNode(_unref(Clock), { class: "w-3 h-3 mr-1 hide-on-480" }),
                      _cache[16] || (_cache[16] = _createTextVNode(" Next available training periods may be in upcoming months ", -1))
                    ])
                  ]))
                : (currentMonthModules.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _createVNode(_unref(Archive), { class: "w-8 h-8 text-blue-500" })
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "text-lg font-medium text-primary-text dark:text-primary-dark-text mb-2" }, "Ready for Training", -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-sm text-secondary-text dark:text-secondary-dark-text mb-4 max-w-sm" }, " You have access to training this month, but no modules are currently available. New modules may be added soon. ", -1)),
                      _createElementVNode("div", _hoisted_103, [
                        _createVNode(_unref(CheckCircle), { class: "w-4 h-4 mr-2" }),
                        _createTextVNode(" " + _toDisplayString(currentMonthName.value) + " access confirmed ", 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_104, [
                      (currentMonthModules.value.length === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentMonthModules.value, (moduleData) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: moduleData.module_id,
                                class: "module-card relative overflow-hidden rounded-lg bg-white dark:bg-gray-800 p-6 border border-gray-200 dark:border-gray-700"
                              }, [
                                _createElementVNode("div", _hoisted_106, [
                                  _createElementVNode("div", _hoisted_107, [
                                    _createElementVNode("div", _hoisted_108, [
                                      _createVNode(_unref(BookOpen), { class: "w-5 h-5 text-primary mr-2" }),
                                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }, "Module this Month", -1))
                                    ]),
                                    _createElementVNode("h4", _hoisted_109, _toDisplayString(moduleData.name), 1),
                                    _createElementVNode("p", _hoisted_110, _toDisplayString(moduleData.description || 'No description available'), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_111, [
                                  _createElementVNode("div", _hoisted_112, [
                                    _createElementVNode("div", _hoisted_113, [
                                      _createVNode(_unref(Clock), { class: "w-4 h-4 text-primary mr-2" }),
                                      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700 dark:text-gray-300" }, "Available Period", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_114, [
                                      (moduleData.time_settings?.[0])
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, _toDisplayString(formatDateRange(moduleData.time_settings[0].start_date, moduleData.time_settings[0].end_date)), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_116, "Not specified"))
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_117, [
                                    _createElementVNode("div", _hoisted_118, [
                                      _createVNode(_unref(ClipboardList), { class: "w-4 h-4 text-primary mr-2" }),
                                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700 dark:text-gray-300" }, "Assessment", -1))
                                    ]),
                                    (moduleData.exam)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                          _createElementVNode("div", _hoisted_120, _toDisplayString(moduleData.exam.name), 1),
                                          _createElementVNode("div", _hoisted_121, [
                                            _createVNode(_unref(Clock), { class: "w-3 h-3 mr-1" }),
                                            _createTextVNode(" " + _toDisplayString(moduleData.exam.time_limit_formatted) + " • " + _toDisplayString(moduleData.exam.passing_rate) + "% to pass ", 1)
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_122, "No exam required"))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_123, [
                                  _createElementVNode("div", _hoisted_124, [
                                    _createVNode(BaseButton, {
                                      icon: _unref(BookOpen),
                                      text: "View Module",
                                      variant: "primary",
                                      size: "md",
                                      onClick: viewModuleRedirect
                                    }, null, 8, ["icon"])
                                  ]),
                                  _createElementVNode("div", _hoisted_125, " Available until " + _toDisplayString(formatEndDate(moduleData.time_settings?.[0]?.end_date)), 1)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_126, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentMonthModules.value, (moduleData) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: moduleData.module_id,
                                class: "flex items-center justify-between p-4 rounded-lg bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 hover:shadow-md transition-shadow duration-200"
                              }, [
                                _createElementVNode("div", _hoisted_127, [
                                  _createElementVNode("div", _hoisted_128, [
                                    _createVNode(_unref(BookOpen), { class: "w-4 h-4 text-blue-500 mr-2" }),
                                    _createElementVNode("h4", _hoisted_129, _toDisplayString(moduleData.name), 1)
                                  ]),
                                  _createElementVNode("p", _hoisted_130, _toDisplayString(moduleData.description || 'No description available'), 1),
                                  _createElementVNode("div", _hoisted_131, [
                                    (moduleData.time_settings?.[0])
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                          _createVNode(_unref(Clock), { class: "w-3 h-3 mr-1" }),
                                          _createTextVNode(" " + _toDisplayString(formatDateRange(moduleData.time_settings[0].start_date, moduleData.time_settings[0].end_date)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (moduleData.exam)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                          _createVNode(_unref(ClipboardList), { class: "w-3 h-3 mr-1" }),
                                          _createTextVNode(" " + _toDisplayString(moduleData.exam.time_limit_formatted), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_134, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass({
                    'px-2 py-1 rounded text-xs font-semibold': true,
                    'bg-green-100 text-green-700 dark:bg-green-900/20 dark:text-green-300': getModuleActiveStatus(moduleData) === 'active',
                    'bg-red-100 text-red-700 dark:bg-red-900/20 dark:text-red-300': getModuleActiveStatus(moduleData) === 'inactive'
                  })
                                  }, _toDisplayString(getModuleActiveStatus(moduleData) === 'active' ? 'Active' : 'Inactive'), 3),
                                  _createElementVNode("div", _hoisted_135, [
                                    _createVNode(BaseButton, {
                                      icon: _unref(BookOpen),
                                      text: "View Module",
                                      variant: "ghost",
                                      size: "sm",
                                      onClick: viewModuleRedirect
                                    }, null, 8, ["icon"])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                    ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})